// extracted by mini-css-extract-plugin
export default {"element":"LargeNumbers-module--element--8650e","link":"LargeNumbers-module--link--b1d1a"};